/**
 * A general-purpose bubble for displaying content. The `ressources` prop is optional and used to render resource links if provided.
 */
const Container = ({
  children,
  classes,
  style,
  htmlId,
}: {
  children?: any;
  classes?: any;
  style?: React.CSSProperties;
  htmlId?: string;
}) => {
  return (
    <div className={`generalContainer ${classes}`} style={style} id={htmlId}>
      {children}
    </div>
  );
};

export default Container;
